// import React, { useState, useEffect } from "react";
// import "react-responsive-carousel/lib/styles/carousel.min.css";
// import { Carousel } from "react-responsive-carousel";
// // import "./styles.scss";
// import { Cursor } from "react-simple-typewriter";
// import Slide0 from "./images/slide-0.png";
// import { scrollToTop } from "../../utils/index";
// import Slide1 from "./images/slide-1.png";
// import Slide2 from "./images/slide-2.png";
// import Slide3 from "./images/slide-3.png";
// import Slide4 from "./images/slide-4.png";
// import Slide5 from "./images/slide-5.png";
// import { Box, Grid, Button, useTheme, useMediaQuery } from "@mui/material";
// import { useNavigate } from "react-router";
// import { useDispatch, useSelector } from "react-redux";
// import { openPremiumSubscriptionModal } from "../../utils/store/slice/appSlice";
// import { homeBookNow, mainBackground3 } from "../../assets";
// import { grey } from "@mui/material/colors";

// const HomeCarousel = () => {
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const isTablet = useMediaQuery(theme.breakpoints.down("md"));

//   const [showText, setShowText] = useState(true);
//   const [autoPlay, setAutoPlay] = useState(false);
//   const [clickedButton, setClickButton] = useState();
//   const dispatch = useDispatch();
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const {
//     images: { banner },
//   } = useSelector((state) => state.appSlice);

//   useEffect(() => {
//     scrollToTop();
//   }, []);
//   function useTypewriter({ words, loop, autoPlay }) {
//     const [textIndex, setTextIndex] = useState(0);
//     const [text, setText] = useState("");

//     useEffect(() => {
//       const interval = setInterval(() => {
//         setText(words[textIndex]);
//         setTextIndex((prevIndex) => (prevIndex + 1) % words.length);
//       }, 1000);

//       return () => {
//         clearInterval(interval);
//       };
//     }, [words, loop]);

//     return { text };
//   }

//   const { text } = useTypewriter({
//     words: ["EXCITEMENT", "THRILL", "ENJOYMENT"],
//     loop: {},
//   });

//   useEffect(() => {
//     setTimeout(() => {
//       setAutoPlay(true);
//     }, 3500);
//   }, []);

//   const getTextOverlayStyles = () => ({
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     zIndex: "10",
//     width: "100vw",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     gap: "10px",
//   });

//   const getCarouselHeight = () => {
//     if (isMobile) return "calc(100vh - 60px)";
//     if (isTablet) return "calc(100vh - 70px)";
//     return "calc(100vh - 84px)";
//   };

//   return (
//     <>
//       <Grid position={"relative"} sx={{ overflow: "hidden" }}>
//         <Grid sx={getTextOverlayStyles()}>
//           <Grid
//             className="car-top-heading"
//             sx={{
//               zIndex: 1,
//               fontFamily: "Saira",
//               width: "100vw",
//               fontSize: "71px",
//               fontWeight: 800,
//               lineHeight: "112px",
//               letterSpacing: "0em",
//               textAlign: "center",
//               color: "white",
//               "@media (max-width: 1015px)": {
//                 fontSize: "60px",
//                 lineHeight: "60px",
//               },
//               "@media (max-width: 881px)": {
//                 textAlign: "center",
//                 fontSize: "30px",
//                 lineHeight: "30px",
//               },
//               "@media (max-width: 441px)": {
//                 fontSize: "24px",
//                 lineHeight: "28px",
//               },
//             }}
//           >
//             Get Ready For
//           </Grid>
//           <Box
//             component="div"
//             className="car-bottom-heading"
//             sx={{
//               fontFamily: "Luckiest Guy !important",
//               fontSize: "100px !important",
//               fontWeight: "400 !important",
//               lineHeight: "85px !important",
//               letterSpacing: "0em !important",
//               textAlign: "center !important",
//               color: "#fff504 !important",
//               display: "block",
//               "@media (max-width: 1015px)": {
//                 fontSize: "60px !important",
//                 lineHeight: "60px !important",
//               },
//               "@media (max-width: 881px)": {
//                 fontSize: "30px !important",
//                 lineHeight: "50px !important",
//               },
//               "@media (max-width: 441px)": {
//                 fontSize: "32px !important",
//                 lineHeight: "36px !important",
//               },
//             }}
//           >
//             {text} <Cursor />
//           </Box>
//         </Grid>

//         <Grid
//           sx={{
//             transition: "filter 0.3s ease",
//             "&::after": {
//               content: '""',
//               position: "absolute",
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               background:
//                 "linear-gradient(135deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.1) 100%)",
//               zIndex: 1,
//             },
//           }}
//         >
//           <Carousel
//             autoPlay={autoPlay}
//             centerMode={true}
//             centerSlidePercentage={100}
//             emulateTouch={true}
//             infiniteLoop={true}
//             interval={2500}
//             transitionTime={800}
//             swipeable={true}
//             stopOnHover={false}
//             showArrows={false}
//             showStatus={false}
//             showIndicators={true}
//             showThumbs={false}
//             onChange={(curr) => {
//               setCurrentSlide(curr);
//               if (curr === 1) {
//                 setShowText(false);
//                 setTimeout(() => {
//                   setCurrentSlide(curr);
//                 }, 500);
//               } else {
//                 setTimeout(() => {
//                   setShowText(true);
//                 }, 500);
//               }
//             }}
//           >
//             <Box
//               maxHeight={getCarouselHeight()}
//               sx={{
//                 "-webkit-user-select": "none",
//                 "-ms-user-select": "none",
//                 "user-select": "none",
//                 "& img": {
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "cover",
//                   display: "block",
//                 },
//               }}
//             >
//               <img src={Slide1} alt={"slide 1"} />
//             </Box>

//             <Box
//               maxHeight={getCarouselHeight()}
//               sx={{
//                 "-webkit-user-select": "none",
//                 "-ms-user-select": "none",
//                 "user-select": "none",
//                 "& img": {
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "cover",
//                   display: "block",
//                 },
//               }}
//             >
//               <img src={Slide2} alt={"slide 2"} />
//             </Box>

//             <Box
//               maxHeight={getCarouselHeight()}
//               sx={{
//                 "-webkit-user-select": "none",
//                 "-ms-user-select": "none",
//                 "user-select": "none",
//                 "& img": {
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "cover",
//                   display: "block",
//                 },
//               }}
//             >
//               <img src={Slide3} alt={"slide 3"} />
//             </Box>

//             <Box
//               maxHeight={getCarouselHeight()}
//               sx={{
//                 "-webkit-user-select": "none",
//                 "-ms-user-select": "none",
//                 "user-select": "none",
//                 "& img": {
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "cover",
//                   display: "block",
//                 },
//               }}
//             >
//               <img src={Slide4} alt={"slide 4"} />
//             </Box>

//             <Box
//               maxHeight={getCarouselHeight()}
//               sx={{
//                 "-webkit-user-select": "none",
//                 "-ms-user-select": "none",
//                 "user-select": "none",
//                 "& img": {
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "cover",
//                   display: "block",
//                 },
//               }}
//             >
//               <img src={Slide5} alt={"slide 5"} />
//             </Box>
//             {banner?.map((img) => (
//               <Box
//                 maxHeight={getCarouselHeight()}
//                 key={img._id}
//                 sx={{
//                   "-webkit-user-select": "none",
//                   "-ms-user-select": "none",
//                   "user-select": "none",
//                   "& img": {
//                     width: "100%",
//                     height: "100%",
//                     objectFit: "cover",
//                     display: "block",
//                   },
//                 }}
//               >
//                 <img src={img.url} alt={"banner image"} />
//               </Box>
//             ))}
//           </Carousel>
//         </Grid>
//       </Grid>

//       <Grid
//         container
//         sx={{
//           width: "100vw",
//           height: { xs: "70vh", sm: "80vh", md: "100vh" },
//           background: `url(${Slide5})`,
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//           backgroundSize: "cover",
//           position: "relative",
//           "&::before": {
//             content: '""',
//             position: "absolute",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             background:
//               "linear-gradient(180deg, rgba(56, 148, 255, 0.85) 0%, rgba(17, 86, 165, 0.85) 100%)",
//             zIndex: 1,
//           },
//         }}
//       >
//         {/* Content Container */}
//         <Grid
//           item
//           xs={12}
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: { xs: "flex-start", sm: "center" },
//             alignItems: "center",
//             height: "100%",
//             zIndex: 2,
//             position: "relative",
//             gap: 2,
//             px: { xs: 2, sm: 4, md: 6 },
//             pt: { xs: 4, sm: 0 },
//           }}
//         >
//           {/* Button Container */}
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 2,
//               width: "100%",
//               maxWidth: { xs: "300px", sm: "400px", md: "500px" },
//             }}
//           >
//             <Button
//               variant="contained"
//               sx={{
//                 backgroundColor: "rgba(255, 255, 255, 0.8)",
//                 boxShadow: "0px 4px 21px -1px rgba(255, 255, 255, 0.8)",
//                 color: "#333",
//                 padding: { xs: "12px 24px", sm: "16px 32px" },
//                 font: "Saira",
//                 fontSize: { xs: "16px", sm: "18px", md: "20px" },
//                 fontWeight: "700",
//                 textTransform: "uppercase",
//                 borderRadius: "bold",
//                 border: "2px solid rgba(255, 255, 255, 0.3)",
//                 backdropFilter: "blur(10px)",
//                 transition: "all 0.3s ease",
//                 "&:hover": {
//                   backgroundColor: "rgba(255, 255, 255, 1)",
//                   transform: "translateY(-2px)",
//                   boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
//                 },
//               }}
//               onClick={() => {
//                 navigate("/packages");
//               }}
//             >
//               PACKAGES
//             </Button>

//             <Button
//               variant="contained"
//               sx={{
//                 backgroundColor: "rgba(255, 255, 255, 0.8)",
//                 boxShadow: "0px 4px 21px -1px rgba(255, 255, 255, 0.8)",
//                 color: "#333",
//                 padding: { xs: "12px 24px", sm: "16px 32px" },
//                 fontSize: { xs: "16px", sm: "18px", md: "20px" },
//                 fontWeight: "bold",
//                 textTransform: "uppercase",
//                 borderRadius: "8px",
//                 border: "2px solid rgba(255, 255, 255, 0.3)",
//                 backdropFilter: "blur(10px)",
//                 transition: "all 0.3s ease",
//                 "&:hover": {
//                   backgroundColor: "rgba(255, 255, 255, 1)",
//                   transform: "translateY(-2px)",
//                   boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
//                 },
//               }}
//               onClick={() => {
//                 navigate("/zone");
//               }}
//             >
//               ACTIVITIES
//             </Button>

//             <Button
//               variant="contained"
//               sx={{
//                 backgroundColor: "rgba(255, 255, 255, 0.8)",
//                 boxShadow: "0px 4px 21px -1px rgba(255, 255, 255, 0.8)",
//                 color: "#333",
//                 padding: { xs: "12px 24px", sm: "16px 32px" },
//                 fontSize: { xs: "16px", sm: "18px", md: "20px" },
//                 fontWeight: "bold",
//                 textTransform: "uppercase",
//                 borderRadius: "8px",
//                 border: "2px solid rgba(255, 255, 255, 0.3)",
//                 backdropFilter: "blur(10px)",
//                 transition: "all 0.3s ease",
//                 "&:hover": {
//                   backgroundColor: "rgba(255, 255, 255, 1)",
//                   transform: "translateY(-2px)",
//                   boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
//                 },
//               }}
//               onClick={() => {
//                 navigate("/events");
//               }}
//             >
//               EVENTS & CELEBRATIONS
//             </Button>

//             <Button
//               variant="contained"
//               sx={{
//                 backgroundColor: "rgba(255, 255, 255, 0.8)",
//                 boxShadow: "0px 4px 21px -1px rgba(255, 255, 255, 0.8)",
//                 color: "#333",
//                 padding: { xs: "12px 24px", sm: "16px 32px" },
//                 fontSize: { xs: "16px", sm: "18px", md: "20px" },
//                 fontWeight: "bold",
//                 textTransform: "uppercase",
//                 borderRadius: "8px",
//                 border: "2px solid rgba(255, 255, 255, 0.3)",
//                 backdropFilter: "blur(10px)",
//                 transition: "all 0.3s ease",
//                 "&:hover": {
//                   backgroundColor: "rgba(255, 255, 255, 1)",
//                   transform: "translateY(-2px)",
//                   boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
//                 },
//               }}
//               onClick={() => {
//                 navigate("/resturant");
//               }}
//             >
//               RESTAURANT & BANQUET HALL
//             </Button>

//             <Button
//               variant="contained"
//               sx={{
//                 backgroundColor: "#4CAF50",
//                 color: "white",
//                 padding: { xs: "14px 28px", sm: "18px 36px" },
//                 fontSize: { xs: "18px", sm: "20px", md: "22px" },
//                 fontWeight: "bold",
//                 textTransform: "uppercase",
//                 borderRadius: "50px",
//                 marginTop: 2,
//                 border: "3px solid rgba(255, 255, 255, 0.3)",
//                 boxShadow: "0 4px 15px rgba(76, 175, 80, 0.4)",
//                 transition: "all 0.3s ease",
//                 "&:hover": {
//                   backgroundColor: "#45a049",
//                   transform: "translateY(-3px) scale(1.02)",
//                   boxShadow: "0 8px 25px rgba(76, 175, 80, 0.6)",
//                 },
//               }}
//               onClick={() => {
//                 navigate("/book");
//               }}
//             >
//               BOOK NOW
//             </Button>
//           </Box>
//         </Grid>
//       </Grid>
//     </>
//   );
// };

// export default HomeCarousel;

import React, { useState, useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
// import "./styles.scss";
import { Cursor } from "react-simple-typewriter";
import Slide0 from "./images/slide-0.png";
import { scrollToTop } from "../../utils/index";
import Slide1 from "./images/slide-1.png";
import Slide2 from "./images/slide-2.png";
import Slide3 from "./images/slide-3.png";
import Slide4 from "./images/slide-4.png";
import Slide5 from "./images/slide-5.png";
import {
  Box,
  Grid,
  Button,
  useTheme,
  useMediaQuery,
  Modal,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { openPremiumSubscriptionModal } from "../../utils/store/slice/appSlice";
import { homeBookNow, mainBackground3 } from "../../assets";
import { grey } from "@mui/material/colors";
import CloseIcon from "@mui/icons-material/Close";

const HomeCarousel = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const [showText, setShowText] = useState(true);
  const [autoPlay, setAutoPlay] = useState(false);
  const [clickedButton, setClickButton] = useState();
  const dispatch = useDispatch();
  const [currentSlide, setCurrentSlide] = useState(0);
  const {
    images: { banner },
  } = useSelector((state) => state.appSlice);

  // ========== HOLI EVENT MODAL STATE - REMOVE AFTER HOLI EVENT ==========
  const [holiModalOpen, setHoliModalOpen] = useState(false);
  // ========== END HOLI EVENT MODAL STATE ==========

  useEffect(() => {
    scrollToTop();
  }, []);

  // ========== HOLI EVENT MODAL AUTO-OPEN & AUTO-CLOSE - REMOVE AFTER HOLI EVENT ==========
  useEffect(() => {
    // Open modal after 1 second when component mounts
    const openTimer = setTimeout(() => {
      setHoliModalOpen(true);
    }, 1000);

    // Auto-close modal after 7 seconds
    const closeTimer = setTimeout(() => {
      setHoliModalOpen(false);
    }, 8000); // 1 second delay + 7 seconds display = 8 seconds total

    return () => {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
    };
  }, []);

  // Function to manually close the modal
  const handleCloseHoliModal = () => {
    setHoliModalOpen(false);
  };

  // Function to navigate to Holi event page
  const handleHoliEventClick = () => {
    setHoliModalOpen(false);
    navigate("/holievent");
  };
  // ========== END HOLI EVENT MODAL FUNCTIONS ==========

  function useTypewriter({ words, loop, autoPlay }) {
    const [textIndex, setTextIndex] = useState(0);
    const [text, setText] = useState("");

    useEffect(() => {
      const interval = setInterval(() => {
        setText(words[textIndex]);
        setTextIndex((prevIndex) => (prevIndex + 1) % words.length);
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }, [words, loop]);

    return { text };
  }

  const { text } = useTypewriter({
    words: ["EXCITEMENT", "THRILL", "ENJOYMENT"],
    loop: {},
  });

  useEffect(() => {
    setTimeout(() => {
      setAutoPlay(true);
    }, 3500);
  }, []);

  const getTextOverlayStyles = () => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: "10",
    width: "100vw",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
  });

  const getCarouselHeight = () => {
    if (isMobile) return "calc(100vh - 60px)";
    if (isTablet) return "calc(100vh - 70px)";
    return "calc(100vh - 84px)";
  };

  return (
    <>
      {/* ========== HOLI EVENT POPUP MODAL - REMOVE AFTER HOLI EVENT ========== */}
      <Modal
        open={holiModalOpen}
        onClose={handleCloseHoliModal}
        aria-labelledby="holi-event-modal"
        aria-describedby="holi-event-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "blur(8px)",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: { xs: "90%", sm: "85%", md: "700px" },
            maxHeight: "90vh",
            overflow: "auto",
            borderRadius: "24px",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
            animation: "scaleIn 0.3s ease-out",
            "@keyframes scaleIn": {
              from: { opacity: 0, transform: "scale(0.9)" },
              to: { opacity: 1, transform: "scale(1)" },
            },
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={handleCloseHoliModal}
            sx={{
              position: "absolute",
              top: { xs: 8, sm: 12 },
              right: { xs: 8, sm: 12 },
              zIndex: 10,
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 1)",
                transform: "scale(1.1)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <CloseIcon sx={{ color: "#e11d48" }} />
          </IconButton>

          {/* Modal Content - Rajasthani Theme */}
          <Box
            sx={{
              background:
                "linear-gradient(135deg, #ff6b9d 0%, #ff8e53 50%, #ffc837 100%)",
              padding: { xs: 3, sm: 4, md: 5 },
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Decorative Pattern Background */}
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                opacity: 0.15,
              }}
            />

            {/* Colorful Border Decoration */}
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "8px",
                background:
                  "repeating-linear-gradient(90deg, #ff006e 0px, #ff006e 20px, #fb5607 20px, #fb5607 40px, #ffbe0b 40px, #ffbe0b 60px, #8338ec 60px, #8338ec 80px, #3a86ff 80px, #3a86ff 100px)",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: "8px",
                background:
                  "repeating-linear-gradient(90deg, #ff006e 0px, #ff006e 20px, #fb5607 20px, #fb5607 40px, #ffbe0b 40px, #ffbe0b 60px, #8338ec 60px, #8338ec 80px, #3a86ff 80px, #3a86ff 100px)",
              }}
            />

            {/* Content Container */}
            <Box sx={{ position: "relative", zIndex: 2, textAlign: "center" }}>
              {/* Decorative Top Icon */}
              <Box
                sx={{
                  fontSize: { xs: "48px", sm: "64px" },
                  marginBottom: 2,
                  animation: "bounce 2s infinite",
                  "@keyframes bounce": {
                    "0%, 100%": { transform: "translateY(0)" },
                    "50%": { transform: "translateY(-10px)" },
                  },
                }}
              >
                🎨🎉
              </Box>

              {/* Main Heading - Rajasthani Style */}
              <Box
                sx={{
                  fontFamily: "'Cinzel Decorative', serif",
                  fontSize: { xs: "32px", sm: "42px", md: "52px" },
                  fontWeight: "bold",
                  color: "#ffffff",
                  textShadow: "3px 3px 6px rgba(0, 0, 0, 0.3)",
                  marginBottom: 1,
                  lineHeight: 1.2,
                }}
              >
                FUNINGO Holi 2.0
              </Box>

              {/* Hindi Subtitle */}
              <Box
                sx={{
                  fontFamily: "'Noto Serif Devanagari', serif",
                  fontSize: { xs: "18px", sm: "24px", md: "28px" },
                  color: "#fffbeb",
                  marginBottom: 3,
                  fontWeight: 500,
                }}
              >
                रंगों का राजसी उत्सव २०२६
              </Box>

              {/* Event Details Card */}
              <Box
                sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.95)",
                  borderRadius: "16px",
                  padding: { xs: 2, sm: 3 },
                  marginBottom: 3,
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
                  border: "3px solid #fbbf24",
                }}
              >
                {/* Date */}
                <Box sx={{ marginBottom: 2 }}>
                  <Box
                    sx={{
                      fontSize: { xs: "14px", sm: "16px" },
                      color: "#6b7280",
                      fontWeight: 600,
                      marginBottom: 0.5,
                    }}
                  >
                    📅 EVENT DATE
                  </Box>
                  <Box
                    sx={{
                      fontSize: { xs: "20px", sm: "24px" },
                      color: "#e11d48",
                      fontWeight: "bold",
                    }}
                  >
                    March 14, 2026
                  </Box>
                </Box>

                {/* Time */}
                <Box sx={{ marginBottom: 2 }}>
                  <Box
                    sx={{
                      fontSize: { xs: "14px", sm: "16px" },
                      color: "#6b7280",
                      fontWeight: 600,
                      marginBottom: 0.5,
                    }}
                  >
                    🕐 TIMING
                  </Box>
                  <Box
                    sx={{
                      fontSize: { xs: "18px", sm: "20px" },
                      color: "#ea580c",
                      fontWeight: "bold",
                    }}
                  >
                    10:00 AM - 6:00 PM
                  </Box>
                </Box>

                {/* Description */}
                <Box
                  sx={{
                    fontSize: { xs: "14px", sm: "16px" },
                    color: "#374151",
                    lineHeight: 1.6,
                    fontWeight: 500,
                  }}
                >
                  Join us for an unforgettable celebration of colors, culture,
                  and adventure! Experience traditional Rajasthani music, dance,
                  unlimited rain dance, musical gulal, and much more! 🎊
                </Box>
              </Box>

              {/* CTA Button */}
              <Button
                variant="contained"
                onClick={handleHoliEventClick}
                sx={{
                  backgroundColor: "#fff",
                  color: "#e11d48",
                  padding: { xs: "14px 32px", sm: "16px 48px" },
                  fontSize: { xs: "16px", sm: "20px" },
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  borderRadius: "50px",
                  border: "4px solid #fbbf24",
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.3)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#fef3c7",
                    transform: "translateY(-4px) scale(1.05)",
                    boxShadow: "0 12px 32px rgba(0, 0, 0, 0.4)",
                  },
                }}
              >
                🎫 Grab Your Pass Now
              </Button>

              {/* Auto-close Timer Text */}
              <Box
                sx={{
                  marginTop: 2,
                  fontSize: { xs: "12px", sm: "14px" },
                  color: "rgba(255, 255, 255, 0.9)",
                  fontStyle: "italic",
                }}
              >
                This popup will close automatically in 7 seconds
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
      {/* ========== END HOLI EVENT POPUP MODAL ========== */}

      <Grid position={"relative"} sx={{ overflow: "hidden" }}>
        <Grid sx={getTextOverlayStyles()}>
          <Grid
            className="car-top-heading"
            sx={{
              zIndex: 1,
              fontFamily: "Saira",
              width: "100vw",
              fontSize: "71px",
              fontWeight: 800,
              lineHeight: "112px",
              letterSpacing: "0em",
              textAlign: "center",
              color: "white",
              "@media (max-width: 1015px)": {
                fontSize: "60px",
                lineHeight: "60px",
              },
              "@media (max-width: 881px)": {
                textAlign: "center",
                fontSize: "30px",
                lineHeight: "30px",
              },
              "@media (max-width: 441px)": {
                fontSize: "24px",
                lineHeight: "28px",
              },
            }}
          >
            Get Ready For
          </Grid>
          <Box
            component="div"
            className="car-bottom-heading"
            sx={{
              fontFamily: "Luckiest Guy !important",
              fontSize: "100px !important",
              fontWeight: "400 !important",
              lineHeight: "85px !important",
              letterSpacing: "0em !important",
              textAlign: "center !important",
              color: "#fff504 !important",
              display: "block",
              "@media (max-width: 1015px)": {
                fontSize: "60px !important",
                lineHeight: "60px !important",
              },
              "@media (max-width: 881px)": {
                fontSize: "30px !important",
                lineHeight: "50px !important",
              },
              "@media (max-width: 441px)": {
                fontSize: "32px !important",
                lineHeight: "36px !important",
              },
            }}
          >
            {text} <Cursor />
          </Box>
        </Grid>

        <Grid
          sx={{
            transition: "filter 0.3s ease",
            "&::after": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background:
                "linear-gradient(135deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.1) 100%)",
              zIndex: 1,
            },
          }}
        >
          <Carousel
            autoPlay={autoPlay}
            centerMode={true}
            centerSlidePercentage={100}
            emulateTouch={true}
            infiniteLoop={true}
            interval={2500}
            transitionTime={800}
            swipeable={true}
            stopOnHover={false}
            showArrows={false}
            showStatus={false}
            showIndicators={true}
            showThumbs={false}
            onChange={(curr) => {
              setCurrentSlide(curr);
              if (curr === 1) {
                setShowText(false);
                setTimeout(() => {
                  setCurrentSlide(curr);
                }, 500);
              } else {
                setTimeout(() => {
                  setShowText(true);
                }, 500);
              }
            }}
          >
            <Box
              maxHeight={getCarouselHeight()}
              sx={{
                "-webkit-user-select": "none",
                "-ms-user-select": "none",
                "user-select": "none",
                "& img": {
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                },
              }}
            >
              <img src={Slide1} alt={"slide 1"} />
            </Box>

            <Box
              maxHeight={getCarouselHeight()}
              sx={{
                "-webkit-user-select": "none",
                "-ms-user-select": "none",
                "user-select": "none",
                "& img": {
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                },
              }}
            >
              <img src={Slide2} alt={"slide 2"} />
            </Box>

            <Box
              maxHeight={getCarouselHeight()}
              sx={{
                "-webkit-user-select": "none",
                "-ms-user-select": "none",
                "user-select": "none",
                "& img": {
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                },
              }}
            >
              <img src={Slide3} alt={"slide 3"} />
            </Box>

            <Box
              maxHeight={getCarouselHeight()}
              sx={{
                "-webkit-user-select": "none",
                "-ms-user-select": "none",
                "user-select": "none",
                "& img": {
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                },
              }}
            >
              <img src={Slide4} alt={"slide 4"} />
            </Box>

            <Box
              maxHeight={getCarouselHeight()}
              sx={{
                "-webkit-user-select": "none",
                "-ms-user-select": "none",
                "user-select": "none",
                "& img": {
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                },
              }}
            >
              <img src={Slide5} alt={"slide 5"} />
            </Box>
            {banner?.map((img) => (
              <Box
                maxHeight={getCarouselHeight()}
                key={img._id}
                sx={{
                  "-webkit-user-select": "none",
                  "-ms-user-select": "none",
                  "user-select": "none",
                  "& img": {
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  },
                }}
              >
                <img src={img.url} alt={"banner image"} />
              </Box>
            ))}
          </Carousel>
        </Grid>
      </Grid>

      <Grid
        container
        sx={{
          width: "100vw",
          height: { xs: "70vh", sm: "80vh", md: "100vh" },
          background: `url(${Slide5})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "linear-gradient(180deg, rgba(56, 148, 255, 0.85) 0%, rgba(17, 86, 165, 0.85) 100%)",
            zIndex: 1,
          },
        }}
      >
        {/* Content Container */}
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: { xs: "flex-start", sm: "center" },
            alignItems: "center",
            height: "100%",
            zIndex: 2,
            position: "relative",
            gap: 2,
            px: { xs: 2, sm: 4, md: 6 },
            pt: { xs: 4, sm: 0 },
          }}
        >
          {/* Button Container */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              width: "100%",
              maxWidth: { xs: "300px", sm: "400px", md: "500px" },
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                boxShadow: "0px 4px 21px -1px rgba(255, 255, 255, 0.8)",
                color: "#333",
                padding: { xs: "12px 24px", sm: "16px 32px" },
                font: "Saira",
                fontSize: { xs: "16px", sm: "18px", md: "20px" },
                fontWeight: "700",
                textTransform: "uppercase",
                borderRadius: "bold",
                border: "2px solid rgba(255, 255, 255, 0.3)",
                backdropFilter: "blur(10px)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 1)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
                },
              }}
              onClick={() => {
                navigate("/packages");
              }}
            >
              PACKAGES
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                boxShadow: "0px 4px 21px -1px rgba(255, 255, 255, 0.8)",
                color: "#333",
                padding: { xs: "12px 24px", sm: "16px 32px" },
                fontSize: { xs: "16px", sm: "18px", md: "20px" },
                fontWeight: "bold",
                textTransform: "uppercase",
                borderRadius: "8px",
                border: "2px solid rgba(255, 255, 255, 0.3)",
                backdropFilter: "blur(10px)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 1)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
                },
              }}
              onClick={() => {
                navigate("/zone");
              }}
            >
              ACTIVITIES
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                boxShadow: "0px 4px 21px -1px rgba(255, 255, 255, 0.8)",
                color: "#333",
                padding: { xs: "12px 24px", sm: "16px 32px" },
                fontSize: { xs: "16px", sm: "18px", md: "20px" },
                fontWeight: "bold",
                textTransform: "uppercase",
                borderRadius: "8px",
                border: "2px solid rgba(255, 255, 255, 0.3)",
                backdropFilter: "blur(10px)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 1)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
                },
              }}
              onClick={() => {
                navigate("/events");
              }}
            >
              EVENTS & CELEBRATIONS
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                boxShadow: "0px 4px 21px -1px rgba(255, 255, 255, 0.8)",
                color: "#333",
                padding: { xs: "12px 24px", sm: "16px 32px" },
                fontSize: { xs: "16px", sm: "18px", md: "20px" },
                fontWeight: "bold",
                textTransform: "uppercase",
                borderRadius: "8px",
                border: "2px solid rgba(255, 255, 255, 0.3)",
                backdropFilter: "blur(10px)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 1)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
                },
              }}
              onClick={() => {
                navigate("/resturant");
              }}
            >
              RESTAURANT & BANQUET HALL
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#4CAF50",
                color: "white",
                padding: { xs: "14px 28px", sm: "18px 36px" },
                fontSize: { xs: "18px", sm: "20px", md: "22px" },
                fontWeight: "bold",
                textTransform: "uppercase",
                borderRadius: "50px",
                marginTop: 2,
                border: "3px solid rgba(255, 255, 255, 0.3)",
                boxShadow: "0 4px 15px rgba(76, 175, 80, 0.4)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "#45a049",
                  transform: "translateY(-3px) scale(1.02)",
                  boxShadow: "0 8px 25px rgba(76, 175, 80, 0.6)",
                },
              }}
              onClick={() => {
                navigate("/book");
              }}
            >
              BOOK NOW
            </Button>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default HomeCarousel;
